import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { isNull } from '../../../../common/src/utils/common';
import { commas, staticPath, getKey } from '../../utils/common';
import { locale } from '../../utils/i18n';
import { onChange } from '../../common/actions';
import CONSTANT, { CACHE } from '../../utils/constants';
import { subsDateFormat, isAmountZero } from '../../controllers/bank-mandate';

class BankDetailsConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchantLogoLoaded: !!(props.merchant && !isNull(props.merchant.logo)),
      merchant: {
        name: null,
        logo: null
      }
    };
    const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
    this.amount = commas(txnAmount);
  }

  componentDidMount = () => {
    const paymentOptions = this.props.cache.getData(CACHE.PAYMENT_OPTIONS);
    // added empty check so that if merchant details is not found an empty object is there to set values
    const merchantDetails = paymentOptions.merchantDetails || {};
    const merchantConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    let merchantNameFromConfig = '';
    // setting name and logo from merchant config  if it exists instead from api
    merchantNameFromConfig = getKey(merchantConfig, 'merchant.name', null);
    const merchantLogoFromConfig = getKey(merchantConfig, 'merchant.logo', null);
    const merchantBrandName = getKey(merchantDetails, 'merchantDisplayName', null);
    if (merchantNameFromConfig) {
      merchantDetails.merchantName = merchantNameFromConfig;
    }
    if (merchantLogoFromConfig) {
      merchantDetails.merchantLogo = merchantLogoFromConfig;
    }
    this.setState({
      merchant: {
        name: merchantDetails.merchantName || merchantBrandName,
        logo: merchantDetails.merchantLogo
      }
    });
  };

  merchantLogoCb = isLoaded => {
    this.setState({ merchantLogoLoaded: isLoaded });
  };

  render(
    { subscription, optedBankData, accountDetails, closeConfirmScreen, genericError, btnDisabled },
    { merchantLogoLoaded, merchant }
  ) {
    return (
      <div className={`ptm-emi-plan-wrap ptm-h100`}>
        <div className={`top-header top-headerbox`}>
          <div className={`ptm-close-wrap ptm-pos-a ptm-closeIcon`} onClick={closeConfirmScreen}>
            <span className={`ptm-cross ptm-pos-r`} />
          </div>
        </div>
        <div className={`sticky-head ptm-w100 ptm-pos-r`}>
          <div className={`willFixed  ptm-pos-r vt ptm-w100-ib reduce relative`}>
            <div className={`ptm-sub-mer-wrap`}>
              <div className={`ptm-w100-ib ptm-vm`}>
                {merchant && (
                  <div className={`ptm-left ptm-sub-mer`}>
                    {merchantLogoLoaded && (
                      <img
                        className={`offusImg`}
                        src={`${merchant.logo}`}
                        height="35"
                        onload={() => this.merchantLogoCb(true)}
                        onerror={() => this.merchantLogoCb(false)}
                      />
                    )}
                    {!merchantLogoLoaded && (
                      <span className={`ptm-txt-control`}>{merchant.name}</span>
                    )}
                  </div>
                )}
                {isAmountZero(this.amount) && (
                  <section className={`ptm-sec-label ptm-right`}>
                    <span className={`ptm-pay-txt`}>
                      Pay &#x20B9;
                      {this.amount}
                    </span>
                    <div className={`ptm-pos-r ptm-sub-txt-header`}>
                      ({locale('bm.amt.deduct')})
                    </div>
                  </section>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className={`ptm-w100-ib`}> */}
        <div className={`ptm-bmdetail`}>
          <div className={`ptm-sub-detail ptm-separator `}>
            <div className={`ptm-sub-heading`}>{locale('bm.subscription.details')}</div>
            {accountDetails.accountHolderName && (
              <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
                <div className={`ptm-sub-name ptm-ib`}>{locale('bm.customer.name')}</div>
                <div className={`ptm-sub-value ptm-ib ptm-right`}>
                  {accountDetails.accountHolderName}
                </div>
              </div>
            )}
            {subscription.subsfrequency && (
              <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
                <div className={`ptm-sub-name ptm-ib`}>{locale('bm.frequency')}</div>
                <div className={`ptm-sub-value ptm-ib ptm-right`}>
                  {subscription.subsfrequency === CONSTANT.SUBS_FREQ_ONDEMAND
                    ? locale('bm.subs.on.demand')
                    : subscription.subsfrequency}
                </div>
              </div>
            )}
            {subscription.maxAmount && (
              <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
                <div className={`ptm-sub-name ptm-ib`}>{locale('bm.max.amount')}</div>
                <div className={`ptm-sub-value ptm-ib ptm-right`}>
                  &#x20B9;
                  {commas(subscription.maxAmount)}
                </div>
              </div>
            )}
            {subsDateFormat(subscription.startDate) && (
              <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
                <div className={`ptm-sub-name ptm-ib`}>{locale('bm.start.date')}</div>
                <div className={`ptm-sub-value ptm-ib ptm-right`}>
                  {subsDateFormat(subscription.startDate)}
                </div>
              </div>
            )}
            <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
              <div className={`ptm-sub-name ptm-ib`}>{locale('bm.exp.date')}</div>
              <div className={`ptm-sub-value ptm-ib ptm-right`}>
                {subsDateFormat(subscription.endDate)
                  ? subsDateFormat(subscription.endDate)
                  : locale('bm.until.cancelled')}
              </div>
            </div>
            {subscription.subscriptionPurpose && (
              <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
                <div className={`ptm-sub-name ptm-ib`}>{locale('bm.purpose')}</div>
                <div className={`ptm-sub-value ptm-ib ptm-right`}>
                  {subscription.subscriptionPurpose}
                </div>
              </div>
            )}
          </div>
          <div className={`ptm-bank-detail ptm-pos-r`}>
            <div className={`ptm-sub-heading`}>{locale('bm.bank.acc.details')}</div>
            <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
              <div className={`ptm-sub-name ptm-ib`}>
                {optedBankData.channelName} {`XX ${accountDetails.accountNumber.slice(-4)}`}
              </div>
            </div>
            {accountDetails.ifsc && (
              <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
                <div className={`ptm-sub-name ptm-ib`}>
                  {locale('bm.ifsc.code')}: {accountDetails.ifsc}
                </div>
              </div>
            )}
            <div className={`ptm-sub-list-wrap ptm-w100-ib`}>
              <div className={`ptm-sub-name ptm-ib`}>{locale('bm.account.saving')}</div>
            </div>
            {optedBankData.iconUrl && (
              <div className={`ptm-pos-a ptm-opt-img ptm-bm-bank-border`}>
                <img
                  className={`ptm-banking-logo centerlized`}
                  src={optedBankData.iconUrl}
                  alt=""
                />
              </div>
            )}
            <div className={`ptm-sub-confirm`}>
              {locale(`bm.confirm.${accountDetails.mandateAuthMode}`)}
            </div>
            <div className={`ifsc-inputwrap ptm-pos-r`}>
              <p className={`ptm-small-txt ptm-msg-red`}>{genericError}</p>
            </div>
          </div>
        </div>
        <div className={`ptm-btn-wrapper ptm-body-bg`}>
          <button
            className={`ptm-custom-btn`}
            disabled={btnDisabled}
            onClick={() => {
              this.props.onConfirm();
            }}
          >
            {locale('bm.confirm')}
          </button>
        </div>
        <div className={`ptm-sub-footer-area`}>
          <img src={`${staticPath()}/assets/images/nach.png`} alt="" />
          <span className={'ptm-footer-txt'}>{locale('bm.mandate.powered')}</span>
          <img src={`${staticPath()}/assets/images/npci.png`} alt="" />
        </div>
      </div>
      // </div>
    );
  }
}

export default connect(
  'cache,subscription',
  onChange
)(BankDetailsConfirm);



// WEBPACK FOOTER //
// ./components/bank-mandate/bank-details-confirm.js